<template>
    <div class="step-two-container content-container" id="loadingdiv">
        <span class="title">
            {{ $t('contact.page.contact.select.label') }}
            <ReglePastille cle="contact.interlocuteursParSite" />
        </span>
        <div class="list-container">
            <InterlocuteurList
                :isLoading="isLoading"
                :selectedInterlocuteur="selectedInterlocuteur"
                :interlocuteurs="interlocuteurs"
                :width="width"
                @pick="pick"
                @sort="sort"
            />
        </div>
    </div>
</template>

<script lang="ts">
import InterlocuteurList from './InterlocuteurList.vue';
import { CONTACT } from '../store/mutation-types';
import { ContactActions } from '../store/action-types';
import { Interlocuteur } from '@/models/Interlocuteur';
import { defineComponent } from 'vue';
import { store } from '@/plugins/store';
import { SortType } from '@/models/SortType';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    components: { InterlocuteurList, ReglePastille },
    data(){
        return {
            width: 0,
        };
    },
    computed: {
        selectedInterlocuteur() {
            return store.state.contactState.interlocuteur;
        },
        interlocuteurs(): Interlocuteur[] {
            return store.state.contactState.interlocuteurs;
        },
        isLoading(): boolean {
            return store.state.contactState.isLoadingInterlocuteurs;
        },
    },
    methods: {
        pick(interlocuteur: Interlocuteur): void {
            if(interlocuteur){
                store.commit(`contactState/${CONTACT.SET_INTERLOCUTEUR}`, interlocuteur);
            }
        },
        sort(sort: {sortData: string, sortStatus: SortType}) {
            let interlocuteurs: Interlocuteur[];
            if (sort.sortData === 'role') {
                interlocuteurs=this.interlocuteurs.sort((a, b) => {
                    if (sort.sortStatus === SortType.ASC) {
                        return this.sortAsc(a.roles[0], b.roles[0]);
                    }
                    if (sort.sortStatus === SortType.DESC) {
                        return this.sortDesc(a.roles[0], b.roles[0]);
                    }
                    return 0;
                });
            } else {
                interlocuteurs=this.interlocuteurs.sort((a, b) => {
                    if (sort.sortStatus === SortType.ASC) {
                        return this.sortAsc(a.nom, b.nom);
                    }
                    if (sort.sortStatus === SortType.DESC) {
                        return this.sortDesc(a.nom, b.nom);
                    }
                    return 0;
                });
            }
            store.commit(`contactState/${CONTACT.SET_LISTE_INTERLOCUTEURS}`, interlocuteurs);
        },
        sortAsc(attributA: string, attributB: string) : number{
            if (attributA > attributB) {
                return -1;
            }
            if (attributA > attributB) {
                return 1;
            }
            return 0;
        },
        sortDesc(attributA: string, attributB: string) {
            if (attributA < attributB) {
                return -1;
            }
            if (attributA > attributB) {
                return 1;
            }
            return 0;
        },
    },
    mounted() {
        if (this.interlocuteurs.length === 0) {
            store.dispatch(`contactState/${ContactActions.GET_INTERLOCUTEURS_LIST}`);
        }
        const loadingElement: typeof HTMLElement | any = document.getElementById('loadingdiv');
        this.width = loadingElement.offsetWidth-48;
    },
});
</script>

<style scoped>
.step-two-container {
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    max-height: calc(100vh - 415px);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 24px;
}
.title {
    color: var(--dark-blue);
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-medium);
}
.list-container {
    margin-top: 8px;
    overflow: auto;
}
</style>
